export interface BDMValue {
  region?: string | null;
  bdm?: string | null;
}

export interface BDMFieldProps {
  value?: BDMValue;
  onChange?: (value: BDMValue) => void;
  readonly?: boolean;
}

export const REGIONS = [
  { label: 'North', value: 'north' },
  { label: 'South', value: 'south' },
  { label: 'East', value: 'east' },
  { label: 'West', value: 'west' },
  { label: 'Central', value: 'central' },
];

export const BDMs_BY_REGION: Record<string, { label: string; value: string; phone: string }[]> = {
  north: [
    { label: 'Alice Johnson', value: 'Alice Johnson', phone: '+44 7700 900001' },
    { label: 'Bob Smith', value: 'Bob Smith', phone: '+44 7700 900002' },
  ],
  south: [
    { label: 'Carol Williams', value: 'Carol Williams', phone: '+44 7700 900003' },
    { label: 'David Brown', value: 'David Brown', phone: '+44 7700 900004' },
  ],
  east: [
    { label: 'Eve Davis', value: 'Eve Davis', phone: '+44 7700 900005' },
    { label: 'Frank Miller', value: 'Frank Miller', phone: '+44 7700 900006' },
  ],
  west: [
    { label: 'Grace Wilson', value: 'Grace Wilson', phone: '+44 7700 900007' },
    { label: 'Henry Moore', value: 'Henry Moore', phone: '+44 7700 900008' },
  ],
  central: [
    { label: 'Isla Taylor', value: 'Isla Taylor', phone: '+44 7700 900009' },
    { label: 'Jack Anderson', value: 'Jack Anderson', phone: '+44 7700 900010' },
  ],
};
